import {API_URL, apiGet} from '../api'
import {ITraderMapProject} from './list'
import {ApiRes} from '../../types/api'

export const getTraderMapDetail = async (id: string): Promise<ApiRes<ITraderMapProject>> => {
    return await apiGet(API_URL, `admin/trader/project/${id}`)
}
